 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"app-Pages-Back-Office-back-office-router-module":"app-Pages-Back-Office-back-office-router-module","canvg":"canvg","default~Pages-accounting-accounting-module~Pages-admin-admin-module~Pages-rate-management-rate-manag~7dd73684":"default~Pages-accounting-accounting-module~Pages-admin-admin-module~Pages-rate-management-rate-manag~7dd73684","default~Pages-accounting-accounting-module~Pages-rate-management-rate-management-module~app-Pages-Fr~de652abd":"default~Pages-accounting-accounting-module~Pages-rate-management-rate-management-module~app-Pages-Fr~de652abd","default~Pages-accounting-accounting-module~Pages-admin-admin-module~app-Pages-Front-desk-lazy-front-~0a3eefdd":"default~Pages-accounting-accounting-module~Pages-admin-admin-module~app-Pages-Front-desk-lazy-front-~0a3eefdd","Pages-accounting-accounting-module":"Pages-accounting-accounting-module","default~Pages-admin-admin-module~Pages-rate-management-rate-management-module~app-Pages-Front-desk-l~ae53dcc3":"default~Pages-admin-admin-module~Pages-rate-management-rate-management-module~app-Pages-Front-desk-l~ae53dcc3","default~Pages-rate-management-rate-management-module~app-Pages-Front-desk-lazy-front-desk-module~app~4562ecf4":"default~Pages-rate-management-rate-management-module~app-Pages-Front-desk-lazy-front-desk-module~app~4562ecf4","default~Pages-admin-admin-module~Pages-rate-management-rate-management-module":"default~Pages-admin-admin-module~Pages-rate-management-rate-management-module","Pages-rate-management-rate-management-module":"Pages-rate-management-rate-management-module","default~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-House-keeping-lazy-house-keeping-modul~c9f386a7":"default~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-House-keeping-lazy-house-keeping-modul~c9f386a7","default~Pages-reports-reports-module~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-Main-lazy~9b9b0983":"default~Pages-reports-reports-module~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-Main-lazy~9b9b0983","default~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-House-keeping-lazy-house-keeping-modul~57631172":"default~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-House-keeping-lazy-house-keeping-modul~57631172","default~Pages-admin-admin-module~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-Main-lazy-main-module":"default~Pages-admin-admin-module~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-Main-lazy-main-module","default~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-Main-lazy-main-module":"default~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-Main-lazy-main-module","app-Pages-Main-lazy-main-module":"app-Pages-Main-lazy-main-module","default~Pages-reports-reports-module~app-Pages-Front-desk-lazy-front-desk-module":"default~Pages-reports-reports-module~app-Pages-Front-desk-lazy-front-desk-module","app-Pages-Front-desk-lazy-front-desk-module":"app-Pages-Front-desk-lazy-front-desk-module","Pages-admin-admin-module":"Pages-admin-admin-module","default~app-Pages-House-keeping-lazy-house-keeping-module~app-Pages-Options-admin-lazy-room-options-module":"default~app-Pages-House-keeping-lazy-house-keeping-module~app-Pages-Options-admin-lazy-room-options-module","app-Pages-House-keeping-lazy-house-keeping-module":"app-Pages-House-keeping-lazy-house-keeping-module","Pages-reports-reports-module":"Pages-reports-reports-module","app-Pages-Options-admin-lazy-room-options-module":"app-Pages-Options-admin-lazy-room-options-module","cross-fetch":"cross-fetch"}[chunkId]||chunkId) + "." + {"app-Pages-Back-Office-back-office-router-module":"86072b38898654d69c4b","canvg":"b62f7c694f4a12be2734","default~Pages-accounting-accounting-module~Pages-admin-admin-module~Pages-rate-management-rate-manag~7dd73684":"5ced03dc91df18380e77","default~Pages-accounting-accounting-module~Pages-rate-management-rate-management-module~app-Pages-Fr~de652abd":"d03b6d8edc97e05970fc","default~Pages-accounting-accounting-module~Pages-admin-admin-module~app-Pages-Front-desk-lazy-front-~0a3eefdd":"59080462386eb1f78a42","Pages-accounting-accounting-module":"77205e00f8c300d8a580","default~Pages-admin-admin-module~Pages-rate-management-rate-management-module~app-Pages-Front-desk-l~ae53dcc3":"47dd87fae8bfb28a03ef","default~Pages-rate-management-rate-management-module~app-Pages-Front-desk-lazy-front-desk-module~app~4562ecf4":"e0bae5e19e8a7fc920ea","default~Pages-admin-admin-module~Pages-rate-management-rate-management-module":"3b03aaf3b89b30f0c9fa","Pages-rate-management-rate-management-module":"1390f08b6ded892c1195","default~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-House-keeping-lazy-house-keeping-modul~c9f386a7":"8cd0f78fd39c0bf9d899","default~Pages-reports-reports-module~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-Main-lazy~9b9b0983":"ed1aaab1629da157657f","default~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-House-keeping-lazy-house-keeping-modul~57631172":"dd9584d9512935551e45","default~Pages-admin-admin-module~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-Main-lazy-main-module":"a7eb781fdcef8c46063f","default~app-Pages-Front-desk-lazy-front-desk-module~app-Pages-Main-lazy-main-module":"1fd222015844ae917432","app-Pages-Main-lazy-main-module":"81cf5d7994b292153175","default~Pages-reports-reports-module~app-Pages-Front-desk-lazy-front-desk-module":"415dadb69fa6f834a9d3","app-Pages-Front-desk-lazy-front-desk-module":"445c027c9ce13ab629ec","Pages-admin-admin-module":"870675860a29a9b86dd7","default~app-Pages-House-keeping-lazy-house-keeping-module~app-Pages-Options-admin-lazy-room-options-module":"f6cbcb49a083e48598a1","app-Pages-House-keeping-lazy-house-keeping-module":"344643090c5e2eae3cfe","Pages-reports-reports-module":"219e85e235376c2a3a31","app-Pages-Options-admin-lazy-room-options-module":"3238e68331e8f39f38a0","cross-fetch":"fd21d8b6eb0888ded69c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
